import React, { CSSProperties } from 'react'

type ArrowRotateType = 'right' | 'left' | 'top' | 'bottom'

const Arrow = (props: {
  color: string
  rotate: 'right' | 'left' | 'top' | 'bottom'
  size: '16' | '24'
  style?: CSSProperties
  onClickFn?: any
}) => {
  const { color, rotate, onClickFn, size, style } = props

  const rotateCovertToNumber: { [key in ArrowRotateType]: number } = {
    right: 0,
    bottom: 90,
    top: 270,
    left: 180,
  }
  const size16 = size === '16'

  return (
    <span style={style} onClick={onClickFn}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        transform={`rotate(${rotateCovertToNumber[rotate]})`}
      >
        <path
          d={size16 ? 'M6 2.34326L11.6569 8.00012L6 13.657' : 'M13 3L3.80761 12.1924L13 21.3848'}
          stroke={color as string}
          strokeWidth={size16 ? '1.6' : '2.4'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

const Search = (props: { style?: CSSProperties; onClickFn: any }) => {
  const { style, onClickFn } = props
  return (
    <span style={style} onClick={onClickFn}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="10.5" cy="10.5" r="7.8" stroke="white" strokeWidth="2.4" />
        <path d="M21.1999 21.2L16.7 16.7" stroke="white" strokeWidth="2.4" strokeLinecap="round" />
      </svg>
    </span>
  )
}

const ClosedWalletBtnBarcode = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 6H4C2.89543 6 2 6.89543 2 8V20C2 21.1046 2.89543 22 4 22H24C25.1046 22 26 21.1046 26 20V8C26 6.89543 25.1046 6 24 6ZM4 4C1.79086 4 0 5.79086 0 8V20C0 22.2091 1.79086 24 4 24H24C26.2091 24 28 22.2091 28 20V8C28 5.79086 26.2091 4 24 4H4Z"
        fill="white"
      />
      <path
        d="M6 10.7059C6 10.316 6.31603 10 6.70588 10H7.29412C7.68397 10 8 10.316 8 10.7059V17.2941C8 17.684 7.68397 18 7.29412 18H6.70588C6.31603 18 6 17.684 6 17.2941V10.7059Z"
        fill="white"
      />
      <path
        d="M10 10.5C10 10.2239 10.2239 10 10.5 10C10.7761 10 11 10.2239 11 10.5V17.5C11 17.7761 10.7761 18 10.5 18C10.2239 18 10 17.7761 10 17.5V10.5Z"
        fill="white"
      />
      <path
        d="M13 10.7059C13 10.316 13.316 10 13.7059 10H14.2941C14.684 10 15 10.316 15 10.7059V17.2941C15 17.684 14.684 18 14.2941 18H13.7059C13.316 18 13 17.684 13 17.2941V10.7059Z"
        fill="white"
      />
      <path
        d="M17 10.5C17 10.2239 17.2239 10 17.5 10C17.7761 10 18 10.2239 18 10.5V17.5C18 17.7761 17.7761 18 17.5 18C17.2239 18 17 17.7761 17 17.5V10.5Z"
        fill="white"
      />
      <path
        d="M20 10.7059C20 10.316 20.316 10 20.7059 10H21.2941C21.684 10 22 10.316 22 10.7059V17.2941C22 17.684 21.684 18 21.2941 18H20.7059C20.316 18 20 17.684 20 17.2941V10.7059Z"
        fill="white"
      />
    </svg>
  )
}

const Reload = (props: { onClickFn?: any }) => {
  const { onClickFn } = props
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClickFn}
    >
      <rect width="38" height="38" rx="10" fill="black" />
      <path
        d="M27.9389 19.7782C27.2452 19.6743 26.6291 20.1424 26.5296 20.8098C26.2798 22.4859 25.4939 24.0153 24.2569 25.233C21.1085 28.3323 15.9895 28.3298 12.8423 25.233C9.69581 22.135 9.69581 17.094 12.8423 13.9966C14.026 12.832 15.5202 12.0728 17.1925 11.7963C17.9117 11.662 18.6848 11.6388 19.4871 11.7283C20.5886 11.8531 21.6139 12.2128 22.5496 12.7411L20.9328 13.0128C20.2573 13.1269 19.8024 13.7584 19.9189 14.424C20.022 15.0197 20.5472 15.4405 21.1414 15.4405C21.2106 15.4405 21.2809 15.4351 21.3524 15.4231L25.6868 14.6937C26.0105 14.6388 26.3004 14.4597 26.4909 14.1946C26.6813 13.9302 26.7565 13.6018 26.7006 13.2819L25.9584 9.01579C25.8444 8.35087 25.2113 7.90552 24.5249 8.01713C23.8494 8.13119 23.3945 8.76334 23.511 9.42887L23.7064 10.5517C22.5043 9.88791 21.1784 9.45845 19.7696 9.29879C18.7145 9.18058 17.691 9.21346 16.7541 9.39011C14.5972 9.74586 12.6374 10.741 11.0862 12.2679C6.97126 16.3186 6.97126 22.9098 11.0862 26.9616C13.1436 28.9875 15.8469 30 18.5496 30C21.2529 30 23.9549 28.9877 26.013 26.9616C27.6297 25.3702 28.6581 23.3658 28.9867 21.1655C29.0863 20.497 28.6168 19.876 27.9389 19.7782Z"
        fill="#999999"
      />
    </svg>
  )
}

const GrayX = (props: { onClickFn?: any }) => {
  const { onClickFn } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      onClick={onClickFn}
    >
      <path
        d="M8.625 16.32L12 12.945L15.375 16.32L16.32 15.375L12.945 12L16.32 8.625L15.375 7.68L12 11.055L8.625 7.68L7.68 8.625L11.055 12L7.68 15.375L8.625 16.32ZM12 21C10.77 21 9.6075 20.7638 8.5125 20.2913C7.4175 19.8188 6.46125 19.1737 5.64375 18.3563C4.82625 17.5388 4.18125 16.5825 3.70875 15.4875C3.23625 14.3925 3 13.23 3 12C3 10.755 3.23625 9.585 3.70875 8.49C4.18125 7.395 4.82625 6.4425 5.64375 5.6325C6.46125 4.8225 7.4175 4.18125 8.5125 3.70875C9.6075 3.23625 10.77 3 12 3C13.245 3 14.415 3.23625 15.51 3.70875C16.605 4.18125 17.5575 4.8225 18.3675 5.6325C19.1775 6.4425 19.8188 7.395 20.2913 8.49C20.7638 9.585 21 10.755 21 12C21 13.23 20.7638 14.3925 20.2913 15.4875C19.8188 16.5825 19.1775 17.5388 18.3675 18.3563C17.5575 19.1737 16.605 19.8188 15.51 20.2913C14.415 20.7638 13.245 21 12 21Z"
        fill="#B3B3B3"
      />
    </svg>
  )
}

const BlackX = (props: { onClickFn?: any }) => {
  const { onClickFn } = props
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClickFn}
    >
      <rect width="38" height="38" rx="10" fill="black" />
      <path
        d="M27 11L11.4437 26.5563"
        stroke="#E6E6E6"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 11L26.5563 26.5563"
        stroke="#E6E6E6"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

const DownLoad = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.17139 7.82861L7.99982 11.657L11.8283 7.82861"
        stroke="#B3B3B3"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 11L8 3" stroke="#B3B3B3" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M3 14H13" stroke="#B3B3B3" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  )
}

const Check = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <path
        d="M7.19531 12.9579L11.5154 17.2776L18.7154 10.0781"
        stroke="white"
        strokeWidth="2.87991"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
const Pin = (props: { color: string }) => {
  const { color } = props
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.87209 14.1H3.97209V14.0919C4.73069 14.0657 5.43765 13.7417 5.97654 13.1692L11.1698 7.65168C11.1699 7.65156 11.1701 7.65143 11.1702 7.6513C11.5031 7.3042 11.6874 6.82951 11.6874 6.33619C11.6874 5.84213 11.5026 5.37426 11.1705 5.0214C10.484 4.29208 9.35922 4.29208 8.67276 5.0214L8.67272 5.02144L3.47881 10.546C3.4788 10.546 3.47878 10.5461 3.47877 10.5461C3.26722 10.7709 3.26723 11.1393 3.47881 11.364C3.69364 11.5923 4.05054 11.5923 4.26538 11.364L9.45933 5.84584C9.71613 5.57301 10.1271 5.57301 10.3839 5.84584L10.3839 5.84586L10.3854 5.84737C10.5107 5.97497 10.5805 6.15471 10.5805 6.34261C10.5805 6.52927 10.5115 6.70386 10.3839 6.83938L5.18997 12.3576C4.48584 13.1057 3.25881 13.1058 2.55452 12.3579C2.20308 11.9783 2.00698 11.4824 2.00698 10.9486C2.00698 10.4143 2.20346 9.91228 2.55421 9.53963L7.74817 4.02143C8.32867 3.40469 9.1008 3.0636 9.9186 3.0636C10.7364 3.0636 11.5085 3.40469 12.089 4.02143C12.6697 4.63836 12.993 5.46162 12.993 6.33619C12.993 7.21076 12.6697 8.03402 12.089 8.65095L8.66672 12.2869C8.45513 12.5117 8.45513 12.8801 8.66672 13.1049C8.88155 13.3332 9.23845 13.3332 9.45328 13.1049L12.8753 9.46925C12.8754 9.46919 12.8755 9.46912 12.8755 9.46906C13.6677 8.63385 14.1 7.5169 14.1 6.33619C14.1 5.15553 13.6678 4.03863 12.8756 3.20343C12.0893 2.36159 11.0353 1.9 9.9186 1.9C8.80191 1.9 7.74781 2.36162 6.96149 3.20353C6.96144 3.20358 6.96138 3.20364 6.96133 3.2037L1.76765 8.72161C1.20535 9.31901 0.9 10.1083 0.9 10.9486C0.9 11.789 1.20535 12.5782 1.76765 13.1756C2.33015 13.7732 3.07577 14.1 3.87209 14.1Z"
        fill={color}
        stroke={color}
        strokeWidth="0.2"
      />
    </svg>
  )
}

const Spin = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    style={{ animation: 'spin 1s linear infinite' }}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeDasharray="31.416"
      strokeDashoffset="31.416"
      style={{
        color: 'white',
        animation: 'spin 1s ease-in-out infinite',
        transformOrigin: 'center',
      }}
    />
    <style>{`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `}</style>
  </svg>
)

export const Icon = {
  Arrow,
  Search,
  ClosedWalletBtnBarcode,
  Reload,
  GrayX,
  BlackX,
  DownLoad,
  Check,
  Pin,
  Spin,
}
